<template>
  <div class="mb-5">
    <admin-org-select class="my-3 text-center" v-model="org"/>
    <training-list :trainings="trainings" @select-training="onSelectTraining"/>
    <div v-if="trainingId" class="mt-5">
      <div class="page-title underline my-3">
        <mdb-icon icon="landmark"/> {{training.name}}
      </div>
      <mdb-row>
        <mdb-col md="8">
          <div class="sub-title"><mdb-icon icon="bell" /> 공지사항</div>
          <notification v-if="training" :perPage="5"/>
        </mdb-col>
        <mdb-col md="4">
          <div class="sub-title mb-3"><mdb-icon icon="clipboard-list" />평가 일정</div>
          <test-schedule/>
        </mdb-col>
      </mdb-row>
      <staff-fail-missing-summary/>
      <staff-summary  v-if="subjects"/>
    </div>
  </div>
</template>
<script>
import { mdbIcon, mdbBtn } from 'mdbvue';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import AdminOrgSelect from '@/components/admin/AdminOrgSelect.vue';
import TrainingCardList from '@/components/common/TrainingCardList.vue';
import TrainingList from './TrainingList.vue';
import Notification from '../../common/notification/Notification.vue';
import StaffSummary from '../../../components/summary/StaffSummary.vue';
import TestSchedule from '../../../components/summary/TestSchedule.vue';
import StaffFailMissingSummary from '../../../components/summary/StaffFailMissingSummary.vue';
export default {
  name: 'StaffHomePage',
  components: { AdminOrgSelect, TrainingList, Notification, StaffSummary, StaffFailMissingSummary, TestSchedule },
  data: () => ({
    org: {},
    trainings: [],
    trainingId: ''
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training', 'subjects'])
  },
  methods: {
    ...mapMutations('training', ['setTraining']),
    ...mapActions('training', ['getSubjects']),
    onSelectTraining (t) {
      this.trainingId = t._id
      try {
        this.setTraining(t)
        this.getSubjects(this.trainingId)
      } catch (e) {
        this.setTraining({})
        console.log(e)
      }
    }
  },
  watch: {
    async org () {
      if (this.org && this.org._id) {
        this.trainings = await this.$Training.list({ org: this.org._id })
      }
    }
  }
}
</script>
